import { Navigate, useLocation } from 'react-router-dom';

// project imports
import { useAuth } from '@clerk/clerk-react';
import { getDynamicDashboardPath } from 'config';
import { GuardProps } from 'types';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
export default function AuthGuard({ children }: GuardProps) {
  const { isSignedIn } = useAuth();
  const location = useLocation();
  const onboardingPath = '/company-onboarding';
  const hasCompany = Boolean(localStorage.getItem('companyId'));

  if (isSignedIn === false) {
    return <Navigate to="/login" replace />;
  }

  if (!hasCompany && location.pathname !== onboardingPath) {
    return <Navigate to={onboardingPath} replace />;
  }

  if (hasCompany && location.pathname === onboardingPath) {
    return <Navigate to={getDynamicDashboardPath()} replace />;
  }

  return children;
}
